import type { Locale } from "./i18n.ts";
import { formatLocalizedCurrency, formatLocalizedNumber } from "./locale-format.ts";
import type { BillingPlan } from "./types.ts";

export const APP_STORE_REFERENCE_CURRENCY = "USD";

export const APP_STORE_REFERENCE_PLANS = [
  { plan: "pro", interval: "monthly", currency: APP_STORE_REFERENCE_CURRENCY, unit_amount: 999 },
  { plan: "pro", interval: "yearly", currency: APP_STORE_REFERENCE_CURRENCY, unit_amount: 7999 },
  { plan: "power", interval: "monthly", currency: APP_STORE_REFERENCE_CURRENCY, unit_amount: 2999 },
  { plan: "power", interval: "yearly", currency: APP_STORE_REFERENCE_CURRENCY, unit_amount: 23999 },
] as const satisfies readonly BillingPlan[];

export function formatReferenceBillingAmount(amount: number, locale: Locale): string {
  return formatLocalizedCurrency(amount / 100, locale, APP_STORE_REFERENCE_CURRENCY, {
    currencyDisplay: "code",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatReferenceBillingPrice(plan: BillingPlan, locale: Locale): string {
  return formatReferenceBillingAmount(plan.unit_amount, locale);
}

export function formatFreeBillingPrice(locale: Locale): string {
  return formatLocalizedNumber(0, locale);
}

export function annualBillingSavings(
  monthlyPlan: BillingPlan | undefined,
  yearlyPlan: BillingPlan | undefined,
): number {
  if (!monthlyPlan || !yearlyPlan || monthlyPlan.currency !== yearlyPlan.currency) return 0;
  return Math.max(0, monthlyPlan.unit_amount * 12 - yearlyPlan.unit_amount);
}
